/*
  Chicks UI · la bolsa (/cart), sección `chicks-carrito`.
  - − / + (botones del formulario con su número) y «Quitar» (url_to_remove)
    funcionan solos sin JS; el campo aplica al salir o con Enter. Con JS todo
    va a /cart/change.js con `sections` (esta sección y `cart-icon-bubble`)
    y se cambia el cuerpo.
  - Mientras espera, los controles de las piezas se apagan. Después el foco
    vuelve al mismo control o, si la pieza ya no está, a la vecina.
  - 422 (no hay existencias): Shopify deja lo que sí pudo y no manda secciones;
    se piden aparte y se pinta un error visible en la pieza, sin cifras.
  - Si el pedido falla de otra forma, se hace lo mismo que sin JS.
  - Barra fija del teléfono: sale sólo mientras «Ir a pagar» sigue más abajo.
  - «Recoge gratis en …» con piezas pendientes: en la bolsa Shopify sólo da
    las sucursales de la primera variante de cada producto; las demás se
    preguntan a /variants/ID?section_id=chicks-carrito (ver la sección).
  - Eventos estándar de Shopify, igual que el carrito de Dawn: `cart:view`
    (el elemento `ck-carrito`), cambio de piezas y error.
*/
(() => {
  if (window.chicksCarrito) return;
  window.chicksCarrito = true;

  const eventos = window.StandardEvents || {};
  if (eventos.createViewEventElement && !customElements.get('ck-carrito')) {
    customElements.define('ck-carrito', eventos.createViewEventElement(HTMLElement));
  }

  const raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sucursales = new Map(); // id de variante → direcciones donde se puede recoger
  let ocupado = false;
  let vigia;

  const pieza = (n) => (n === 1 ? 'pieza' : 'piezas');

  // El texto arranca visible con «Viendo dónde…» (la sección ya reserva el
  // espacio, sin hidden) para no dar un salto cuando llegue la respuesta.
  // `sucursales` cachea por variante: una pieza que ya se preguntó no se
  // vuelve a pedir aunque cambie la cantidad y la sección se repinte.
  async function resolverRetiro(caja) {
    const ids = caja.dataset.ckPendientes.split(',');
    try {
      await Promise.all(ids.filter((id) => !sucursales.has(id)).map(async (id) => {
        const r = await fetch(`${raizTienda}variants/${id}?section_id=chicks-carrito`);
        if (!r.ok) throw new Error(r.status);
        const dato = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-ck-sucursales]');
        sucursales.set(id, dato ? dato.dataset.ckSucursales.split('|').filter(Boolean) : []);
      }));
    } catch (e) {
      caja.querySelector('b').textContent = 'No pudimos ver dónde se recoge tu pedido';
      caja.querySelector('.ck-resumen__retiro-detalle').textContent = 'Puedes verlo al pagar.';
      caja.dataset.ckEstado = 'error';
      return;
    }
    let comunes = caja.dataset.ckRetiro ? caja.dataset.ckRetiro.split('|') : null;
    for (const id of ids) {
      const aqui = sucursales.get(id);
      comunes = comunes ? comunes.filter((s) => aqui.includes(s)) : aqui;
    }
    if (comunes.length) {
      caja.querySelector('b').textContent = `Recoge gratis en ${comunes.join(' o ')}`;
      caja.querySelector('.ck-resumen__retiro-detalle').textContent = 'Lo eliges al pagar, en lugar del envío.';
    } else {
      // Nadie cubre todo el pedido: sin el detalle de qué pieza falta (eso
      // sólo lo calcula Liquid con lo que ya conocía al cargar), mejor
      // callarse que dar un «recoge en ninguna parte» confuso.
      caja.hidden = true;
    }
  }

  function preparar(raiz) {
    const caja = raiz.querySelector('[data-ck-pendientes]');
    if (caja) resolverRetiro(caja);
    if (vigia) { vigia.pagar.disconnect(); vigia.pie?.disconnect(); }
    const barra = raiz.querySelector('[data-ck-barra]');
    const pagar = raiz.querySelector('.ck-resumen [name="checkout"]');
    const pie = document.querySelector('.ck-pie');
    if (!barra || !pagar) return;
    // El margen de arriba estira el área vigilada: «fuera» sólo puede ser
    // «abajo». Un segundo vigía la esconde otra vez al llegar al pie, para
    // que no se lo tape.
    const pintar = () => {
      const ver = raiz.dataset.ckPasoPagar === 'true' && raiz.dataset.ckPie !== 'true';
      barra.classList.toggle('ck-ver', ver);
      barra.inert = !ver;
    };
    vigia = {
      pagar: new IntersectionObserver(([en]) => { raiz.dataset.ckPasoPagar = String(!en.isIntersecting); pintar(); }, { rootMargin: '100000px 0px 0px 0px' }),
      pie: pie && new IntersectionObserver(([en]) => { raiz.dataset.ckPie = String(en.isIntersecting); pintar(); }),
    };
    vigia.pagar.observe(pagar);
    if (vigia.pie) vigia.pie.observe(pie);
  }

  function pintar(raiz, secciones) {
    const doc = new DOMParser().parseFromString(secciones[raiz.dataset.ckCarrito], 'text/html');
    const nuevo = doc.querySelector('[data-ck-cuerpo]');
    if (!nuevo) throw new Error('sin sección');
    raiz.querySelector('[data-ck-cuerpo]').replaceWith(nuevo);
    const bolsa = document.getElementById('cart-icon-bubble');
    const html = secciones['cart-icon-bubble'];
    const b = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (bolsa && b) bolsa.innerHTML = b.innerHTML;
    preparar(raiz);
  }

  function anunciar(raiz, texto) {
    const vivo = raiz.querySelector('[data-ck-anuncio]');
    vivo.textContent = '';
    setTimeout(() => { vivo.textContent = texto; }, 60);
  }

  async function cambiar(raiz, linea, cantidad, control) {
    if (ocupado) return;
    ocupado = true;
    const clave = linea.dataset.ckLinea;
    const nombre = linea.dataset.ckNombre;
    const claves = [...raiz.querySelectorAll('[data-ck-linea]')].map((l) => l.dataset.ckLinea);
    const i = claves.indexOf(clave);
    const ids = `${raiz.dataset.ckCarrito},cart-icon-bubble`;
    let error = '';
    let cambioConfirmado = false;

    // readOnly y no disabled: si justo se da clic en «Pagar», el campo sí viaja.
    raiz.setAttribute('aria-busy', 'true');
    raiz.querySelectorAll('[data-ck-cant]').forEach((c) => { c.readOnly = true; });
    raiz.querySelectorAll('[data-ck-paso]').forEach((a) => a.setAttribute('aria-disabled', 'true'));

    const { CartLinesUpdateEvent, CartErrorEvent } = eventos;
    const diferido = CartLinesUpdateEvent && CartLinesUpdateEvent.createPromise();
    if (diferido) {
      raiz.dispatchEvent(new CartLinesUpdateEvent({
        action: cantidad === 0 ? 'remove' : 'update',
        context: 'cart',
        lines: [{ id: clave, quantity: cantidad }],
        promise: diferido.promise,
      }));
    }

    const pedir = (ruta, datos) => fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...datos, sections: ids, sections_url: raiz.dataset.ckUrl }),
    });

    try {
      let r = await pedir(`${raiz.dataset.ckCambiar}.js`, { id: clave, quantity: cantidad });
      if (r.status === 422) {
        const fallo = await r.json();
        error = `Por ahora no tenemos más de ${nombre}.`;
        if (CartErrorEvent) raiz.dispatchEvent(new CartErrorEvent({ error: fallo.description, code: 'INVALID' }));
        // Shopify dejó lo que sí pudo pero no manda secciones; un update vacío trae bolsa y secciones.
        r = await pedir(`${raiz.dataset.ckUrl}/update.js`, {});
      }
      if (!r.ok) throw new Error(r.status);
      cambioConfirmado = true;
      const res = await r.json();
      diferido?.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(res) });
      pintar(raiz, res.sections);
    } catch (e) {
      diferido?.reject(e);
      // La mutación puede haber terminado aunque una sección no se renderice.
      // Repetir el enlace de quitar usaría una línea que ya no existe.
      if (cambioConfirmado) {
        location.href = raiz.dataset.ckUrl;
        return;
      }
      if (control.matches('a')) location.href = control.href;
      else control.form.requestSubmit(control.matches('button') ? control : null);
      return;
    } finally {
      ocupado = false;
      raiz.removeAttribute('aria-busy');
    }

    const vecina = claves[i + 1] || claves[i - 1];
    const foco = (control && document.getElementById(control.id))
      || (vecina && document.getElementById(`ck-nombre-${vecina}`))
      || document.getElementById('ck-carrito-titulo');
    foco?.focus();

    const sigue = document.getElementById(`ck-cant-${clave}`);
    const aviso = sigue && sigue.closest('[data-ck-linea]').querySelector('[data-ck-error]');
    if (error && aviso) {
      aviso.textContent = error;
      aviso.hidden = false;
    }
    const q = sigue ? Number(sigue.value) : 0;
    const subtotal = raiz.querySelector('[data-ck-subtotal]')?.textContent.trim();
    const envio = raiz.querySelector('[data-ck-envio]')?.textContent.trim();
    const hecho = sigue ? `${nombre}: ${q} ${pieza(q)}` : `Quitaste ${nombre} de tu bolsa`;
    const partes = subtotal ? [error || hecho, `Subtotal ${subtotal}`, envio] : [hecho, 'Tu bolsa quedó vacía'];
    anunciar(raiz, `${partes.filter(Boolean).map((t) => t.replace(/\.$/, '')).join('. ')}.`);
  }

  const raizDe = (el) => el.closest('[data-ck-carrito]');

  document.addEventListener('click', (e) => {
    const paso = e.target.closest('[data-ck-carrito] [data-ck-paso]');
    if (!paso) return;
    e.preventDefault();
    const cantidad = paso.matches('a') ? 0 : Math.max(0, Number(paso.value));
    cambiar(raizDe(paso), paso.closest('[data-ck-linea]'), cantidad, paso);
  });

  // Vacío o igual que antes no pide nada: el campo vuelve a su número.
  document.addEventListener('change', (e) => {
    const campo = e.target.closest('[data-ck-carrito] [data-ck-cant]');
    if (!campo || campo.readOnly) return;
    const cantidad = parseInt(campo.value, 10);
    if (Number.isNaN(cantidad) || cantidad < 0 || cantidad === Number(campo.defaultValue)) {
      campo.value = campo.defaultValue;
      return;
    }
    cambiar(raizDe(campo), campo.closest('[data-ck-linea]'), cantidad, campo);
  });

  // Enter en el campo no manda el formulario: con JS su botón por defecto sería un −.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.matches('[data-ck-carrito] [data-ck-cant]')) return;
    e.preventDefault();
    e.target.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const iniciar = () => document.querySelectorAll('[data-ck-carrito]').forEach(preparar);
  iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  // El cajón de la bolsa repinta el cuerpo por su cuenta (chicks-ui.js) y
  // avisa aquí para volver a enganchar lo que no va por delegación.
  document.addEventListener('ck:carrito', iniciar);
})();
